import React from 'react';
import ReactFileReader from 'react-file-reader';
import { Card, CardHeader, Row, Col, CardFooter } from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Document, Page } from 'react-pdf';
import DatePicker from 'react-datepicker';
import { environment } from '../../../../environment/environment';
import apiResponseHandler from '../../../../utils/apiResponseHandler';
import 'react-datepicker/dist/react-datepicker.css';

class EmployeeDocumentUploadModal extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      employer: null,
      file: null,
      singleIssueDate: null,
      rangeIssueDate: [null, null],
      distributionTime: null,
      singlarDocumentName: '',
    };
  }

  componentDidMount(prevProps, prevState) {
    if (this.props.documentType === 'irp5s') {
      this.setState({
        singlarDocumentName: 'IRP5',
      });
    } else if (this.props.documentType === 'payslips') {
      this.setState({
        singlarDocumentName: 'Payslip',
      });
    } else if (this.props.documentType === 'timesheets') {
      this.setState({
        singlarDocumentName: 'Timesheet',
      });
    } else if (this.props.documentType === 'rosters') {
      this.setState({
        singlarDocumentName: 'Roster',
      });
    }

  }

  selectSingleIssueDate = (singleDate) => {
    this.setState({ singleIssueDate: singleDate });
  };

  selectRangeIssueDate = (dateRange) => {
    this.setState({ rangeIssueDate: dateRange });
  };

  selectDistributionTime = (distributionTime) => {
    this.setState({ distributionTime });
  };

  handleFiles = (files) => {
    this.setState({ loading: true });
    const reader = new FileReader();
    reader.onload = (e) => {
      // Use reader.result
      this.setState({
        loading: false,
        file: files[0],
      });
    };
    reader.readAsDataURL(files[0]);
  };

  confirmUpload = async (isCreateNew = false) => {
    const action = isCreateNew ? 'Create ' : 'Update';
    const result = await Swal.fire({
      title: `${action} File?`,
      text: `Are you sure you want to \n${action} the ${this.state.singlarDocumentName.toLowerCase()} for \n${this.props.employeeData.first_name} ${this.props.employeeData.last_name} with file ${this.state.file.name} ?`,
      icon: 'warning',
      showCancelButton: true,
      focusCancel: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, upload it!',
    });

    return result.isConfirmed;
  };

  getOffSetDateTime = (dateTime) => {
    const offSet = dateTime.getTimezoneOffset();
    const offSetDateTime = new Date(dateTime.getTime() - offSet * 60 * 1000);
    return offSetDateTime.toISOString();
  };

  createNewDocument = async () => {
    const continueUpload = await this.confirmUpload(true);

    if (continueUpload) {
      Swal.fire({
        title: `Uploading ${this.state.singlarDocumentName.toLowerCase()}`,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      const headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
      };
      const { file } = this.state;
      const bodyFormData = new FormData();

      bodyFormData.append('employee', this.props.employeeData.id);

      let url = `${environment.baseUrl}/employee_payslips/`;
      if (this.props.documentType === 'payslips') {
        bodyFormData.append('payslip_file', file);
        bodyFormData.append('verification_status', 'pending');
      }
      else if (this.props.documentType === 'irp5s') {
        bodyFormData.append('irp5_file', file);
        bodyFormData.append('status', 'imported');
        url = `${environment.baseUrl}/employee_irp5s/`;
      }
      else if (this.props.documentType === 'timesheets') {
        bodyFormData.append('timesheet_file', file);
        bodyFormData.append('status', 'imported');
        url = `${environment.baseUrl}/employee_timesheet/`;
      }
      else if (this.props.documentType === 'rosters') {
        bodyFormData.append('roster_file', file);
        bodyFormData.append('status', 'imported');
        url = `${environment.baseUrl}/employee_roster/`;
      }

      if (this.state.singleIssueDate) {
        bodyFormData.append(
          'date_issued',
          this.getOffSetDateTime(this.state.singleIssueDate).split('T')[0],
        );
      } else if (this.state.rangeIssueDate[0] && this.state.rangeIssueDate[1]) {
        bodyFormData.append(
          'period_start_date',
          this.getOffSetDateTime(this.state.rangeIssueDate[0]).split('T')[0],
        );
        bodyFormData.append(
          'period_end_date',
          this.getOffSetDateTime(this.state.rangeIssueDate[1]).split('T')[0],
        );
        bodyFormData.append(
          'date_issued',
          this.getOffSetDateTime(this.state.rangeIssueDate[0]).split('T')[0],
        );
      }

      bodyFormData.append(
        'date_of_distribution',
        this.state.distributionTime.toISOString(),
      );

      axios
        .post(url, bodyFormData, {
          headers,
        })
        .then((_res) => {
          Swal.fire({
            title: 'File uploaded',
            showConfirmButton: false,
            icon: 'success',
            timer: 3000,
          });
          this.props.updateModalState(false, true);
        })
        .catch((error) => {
          apiResponseHandler.handleApiError('Error', error);
        });
    }
  };

  updateDocument = async () => {
    const continueUpload = await this.confirmUpload();

    if (continueUpload) {
      Swal.fire({
        title: `Uploading ${this.state.singlarDocumentName.toLowerCase()}`,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      const headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
      };
      const { file } = this.state;
      const bodyFormData = new FormData();

      let url = `${environment.baseUrl}/employee_payslips/${this.props.documentId}/`;
      if (this.props.documentType === 'payslips') {
        bodyFormData.append('payslip_file', file);
        bodyFormData.append(
          'verification_status',
          this.props.selectedDocument.verification_status,
        );
        bodyFormData.append(
          'date_issued',
          this.props.selectedDocument.date_issued,
        );
      } else if (this.props.documentType === 'irp5s') {
        bodyFormData.append('irp5_file', file);
        bodyFormData.append(
          'status',
          this.props.selectedDocument.status,
        );
        url = `${environment.baseUrl}/employee_irp5s/${this.props.documentId}/`;
      } else if (this.props.documentType === 'timesheets') {
        bodyFormData.append('timesheet_file', file);
        bodyFormData.append('timesheet_image_file', null);
        bodyFormData.append('period_start_date', this.props.selectedDocument.period_start_date);
        bodyFormData.append('period_end_date', this.props.selectedDocument.period_end_date);
        bodyFormData.append(
          'status',
          this.props.selectedDocument.status,
        );
        url = `${environment.baseUrl}/employee_timesheet/${this.props.documentId}/`;
      } else if (this.props.documentType === 'rosters') {
        bodyFormData.append('roster_file', file);
        bodyFormData.append('roster_image_file', null);
        bodyFormData.append('period_start_date', this.props.selectedDocument.period_start_date);
        bodyFormData.append('period_end_date', this.props.selectedDocument.period_end_date);
        bodyFormData.append(
          'status',
          this.props.selectedDocument.status,
        );
        url = `${environment.baseUrl}/employee_roster/${this.props.documentId}/`;
      }

      bodyFormData.append('employee', this.props.selectedDocument.employee);

      bodyFormData.append(
        'date_of_distribution',
        this.props.selectedDocument.date_of_distribution,
      );

      axios
        .put(
          url,
          bodyFormData,
          {
            headers,
          },
        )
        .then((_res) => {
          Swal.fire({
            title: `${this.state.singlarDocumentName} uploaded`,
            showConfirmButton: false,
            icon: 'success',
            timer: 3000,
          });
          this.props.updateModalState(false, true);
        })
        .catch((error) => {
          apiResponseHandler.handleApiError('Error', error);
        });
    }
  };

  render() {
    return (
      <div
        style={{
          position: 'fixed',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          left: 0,
          top: 0,
          zIndex: 10,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(100,100,100,0.4)',
        }}
      >
        <Card
          style={{
            maxWidth: '100vw',
            width: '95vw',
            maxHeight: '95vh',
            margin: 'auto',
            backgroundColor: 'white',
          }}
        >
          <CardHeader>
            <Row>
              {this.props.isCreateNew && (
                <Col style={{ display: 'flex' }} lg="9">
                  <Col style={{ display: 'flex' }} lg="6">
                    <div style={{ marginRight: '12px', width: '50%' }}>
                      Issue Date / Pay Period{' '}
                    </div>
                    <div>
                      {
                        ["timesheets", "rosters"].includes(this.props.documentType) ? (
                          <>
                            <DatePicker
                              selected={this.state.rangeIssueDate[0]}
                              onChange={(date) => this.selectRangeIssueDate([date, this.state.rangeIssueDate[1]])}
                              dateFormat="MMM d, yyyy"
                              placeholderText="Start Date"
                            />
                            <DatePicker
                              selected={this.state.rangeIssueDate[1]}
                              onChange={(date) => {
                                if (date <= this.state.rangeIssueDate[0]) {
                                  Swal.fire({
                                    title: 'Error',
                                    text: 'End date cannot be before start date',
                                    icon: 'error',
                                    toast: true,
                                    position: 'top',
                                    showConfirmButton: false,
                                    timer: 3000,
                                    timerProgressBar: true,
                                  });
                                  // add a delay to date
                                  const newDate = new Date(this.state.rangeIssueDate[0].getTime() + 86400000);
                                  this.selectRangeIssueDate([this.state.rangeIssueDate[0], newDate]);
                                } else {
                                  this.selectRangeIssueDate([this.state.rangeIssueDate[0], date]);
                                }
                              }}
                              dateFormat="MMM d, yyyy"
                              disabled={!this.state.rangeIssueDate[0]}
                              placeholderText="End Date"
                            />
                          </>
                        ) : (
                          <DatePicker
                            selected={this.state.singleIssueDate}
                            onChange={this.selectSingleIssueDate}
                            dateFormat="MMM d, yyyy"
                          />
                        )
                      }
                    </div>
                  </Col>

                  <Col style={{ display: 'flex' }} lg="6">
                    <div style={{ marginRight: '12px' }}>
                      Distribution Time{' '}
                    </div>
                    <div>
                      <DatePicker
                        timeIntervals={5}
                        selected={this.state.distributionTime}
                        onChange={(date) => this.selectDistributionTime(date)}
                        showTimeSelect
                        dateFormat="MMM d, yyyy h:mm aa"
                      />
                    </div>
                  </Col>
                </Col>
              )}

              <Col style={{ display: 'flex', justifyContent: 'flex-end' }}>
                {this.props.isCreateNew && (
                  <button
                    className="btn btn-success"
                    onClick={this.createNewDocument}
                    disabled={
                      !this.state.file ||
                      !this.state.distributionTime
                    }
                  >
                    Create New {this.state.singlarDocumentName}
                  </button>
                )}

                {!this.props.isCreateNew && (
                  <button
                    className="btn btn-primary"
                    onClick={this.updateDocument}
                    disabled={!this.state.file}
                  >
                    Update {this.state.singlarDocumentName}
                  </button>
                )}

                <button
                  className="btn btn-secondary"
                  onClick={() => this.props.updateModalState(false, false)}
                >
                  Close
                </button>
              </Col>
            </Row>
          </CardHeader>

          <Row className="my-3">
            <Col
              className="justify-content-left"
              lg="3"
              style={{ marginLeft: '32px', borderRight: '1px dotted' }}
            >
              <Row>
                <div style={{ margin: 'auto' }}>
                  <h2>Employee Details</h2>
                </div>
              </Row>

              <Row>
                <Col lg="6">
                  <strong>Id number</strong>
                </Col>
                <Col>
                  <span>{this.props.employeeData.id_number}</span>
                </Col>
              </Row>

              <Row>
                <Col lg="6">
                  <strong>Employee number</strong>
                </Col>
                <Col>
                  <span>{this.props.employeeData.employee_no}</span>
                </Col>
              </Row>

              <Row>
                <Col lg="6">
                  <strong>Employee name</strong>
                </Col>
                <Col>
                  <span>{`${this.props.employeeData.first_name} ${this.props.employeeData.last_name}`}</span>
                </Col>
              </Row>

              <Row>
                <Col lg="6">
                  <strong>Bank</strong>
                </Col>
                <Col>
                  <span>{this.props.employeeData.bank_name}</span>
                </Col>
              </Row>

              <Row>
                <Col lg="6">
                  <strong>Account Number</strong>
                </Col>
                <Col>
                  <span>{this.props.employeeData.bank_account_number}</span>
                </Col>
              </Row>
            </Col>

            <Col className=" justify-content-center" lg="6">
              {!this.state.file && (
                <div className="align-items-center">
                  <strong>
                    <i>Please upload a file to update the {this.state.singlarDocumentName.toLowerCase()}</i>
                  </strong>
                </div>
              )}

              {this.state.file && (
                <div>
                  <div>
                    <strong>
                      <i>
                        The current document will be replaced with the following
                        one
                      </i>
                    </strong>
                  </div>

                  <div style={{ overflow: 'scroll', maxHeight: '500px' }}>
                    {this.state.file && (
                      <Document file={this.state.file}>
                        <Page pageNumber={1} />
                      </Document>
                    )}
                  </div>
                </div>
              )}
            </Col>
          </Row>

          <CardFooter
            style={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <ReactFileReader
                multipleFiles={false}
                fileTypes={['.pdf']}
                handleFiles={this.handleFiles}
              >
                <button className="btn btn-primary">Choose file</button>
              </ReactFileReader>
            </div>
          </CardFooter>
        </Card>
      </div>
    );
  }
}

export default EmployeeDocumentUploadModal;
